import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import ImportDocumentsListView from "./import_documents-list.html";


angular.module("import_documents", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
           .state('import_documents', {
               url: "/import_documents",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                cache: false,
            })
            .state('import_documents.list', {
                url: "/list",
                controller: "ImportDocumentsListCtrl",
                template: ImportDocumentsListView,
                data: { pageTitle: 'Importación de datos' },
                cache: false,
                requiredPermission: ["IMPORT_DOCUMENT_READ"]
            })
        ;

    }])
;